import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export enum PlacementType {
  Whitelist = "Whitelist",
  Blacklist = "Blacklist",
}

export interface BrandCampaignPromoAdsWhitelistDialogData {
  type: PlacementType;
  placements: string[];
}

export type BrandCampaignPromoAdsWhitelistDialogResult = string[];

@Component({
  selector: "app-brand-campaign-promo-ads-whitelist-dialog",
  templateUrl: "./brand-campaign-promo-ads-whitelist-dialog.component.html",
  styleUrl: "./brand-campaign-promo-ads-whitelist-dialog.component.scss",
})
export class BrandCampaignPromoAdsWhitelistDialogComponent {
  public newPlacementsInput = "";
  public placements: string[] = [];
  public title: string;

  constructor(
    public dialogRef: MatDialogRef<
      BrandCampaignPromoAdsWhitelistDialogComponent,
      BrandCampaignPromoAdsWhitelistDialogResult
    >,
    @Inject(MAT_DIALOG_DATA)
    data: BrandCampaignPromoAdsWhitelistDialogData,
  ) {
    this.placements = data.placements;
    this.title =
      data.type === PlacementType.Blacklist
        ? "brand.campaign.promoAds.placements.blacklistPlacements"
        : "brand.campaign.promoAds.placements.whitelistPlacements";
  }

  public getNumberOfLines(): number {
    return this.newPlacementsInput.split("\n").length;
  }

  public addPlacements(): void {
    const newPlacements = this.newPlacementsInput
      .split("\n")
      .filter((line) => line.trim() !== "");

    this.placements.push(...newPlacements);
    this.newPlacementsInput = "";
  }

  public removePlacement(index: number): void {
    this.placements.splice(index, 1);
  }

  public save(): void {
    this.dialogRef.close(this.placements);
  }
}
